import CircularProgress from '@mui/material/CircularProgress';

/**
 * Anticipation state shown while the sample demo project is being provisioned, so
 * the sample door never lands on a blank spinner. Sets the expectation that the
 * demo is being prepared and teaches what to expect on the other side.
 */
export function DemoProvisioningState() {
	return (
		<div className='flex w-full max-w-2xl flex-col items-center gap-6 rounded-xl border border-gray-a6 bg-gray-2 p-12 text-center'>
			<CircularProgress />
			<div className='flex flex-col gap-2'>
				<h2 className='text-3xl font-semibold'>Preparing your sample project</h2>
				<p className='text-gray-a11'>
					We are setting up an example design so you can see Cadstrom’s validation findings and evidence. This only
					takes a moment.
				</p>
			</div>
		</div>
	);
}
